// frontend/src/AdminRoute.js
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from './useAuth';

const AdminRoute = ({ children }) => {
    const { isAuthenticated, isStaff } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }
    if (!isStaff) {
        return <Navigate to="/" />;
    }

    return children;
};

export default AdminRoute;
